import APIServiceLookUp from './serviceAPI';
import { MAIN_API_URL } from './models/AppConstent';

export default class ServiceBooking {
    lookupService = new APIServiceLookUp();

    async createBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}booking/setBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getBookingsByFilter(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}booking/getBookingsByFilter`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}booking/updateBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async checkinBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}booking/checkinBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async checkoutBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}booking/checkoutBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}